export function getProxyClass(Cls) {
    const base = new Cls({});
    return new Proxy(Cls, {
        construct(t, p) {
            return Reflect.construct(t, p);
        },
        get(_, p, r) {
            return Reflect.get(base, p, r);
        }
    });
}
//# sourceMappingURL=GetProxyClass.js.map